import React, { useContext } from "react";
import { usePrivacy } from "@queries/usePrivacy";
import { ApplicationContext } from "@context/ApplicationContext";
import Loader from "@components/Ui/Loader";
import "./style.scss";

const Privacy = () => {
    const { subscriberGroupId } = useContext(ApplicationContext);
    const { privacyPolicy, isLoading } = usePrivacy(subscriberGroupId);

    if (isLoading) {
        return <Loader isLoading={isLoading} />;
    }

    return (
        <div className="privacy__wrapper admin-content">
            {privacyPolicy ? (
                // eslint-disable-next-line react/no-danger
                <div className="privacy__content" dangerouslySetInnerHTML={{ __html: privacyPolicy }} />
            ) : (
                <p className="paragraph">Privacy policy content to follow</p>
            )}
        </div>
    );
};

export default Privacy;
